// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"JQ-z","categoryName":"KQ-z","categoryNameSearchHeader":"LQ-z","categoryContent":"MQ-z","bottomAligned":"NQ-z","image":"OQ-z","imageNoBackground":"PQ-z"};